export default __webpack_public_path__ + "static/media/dunno.14f34fea.svg";